import * as React from "react";
const SvgDownloadFilled = props => <svg xmlns="http://www.w3.org/2000/svg" width={16.471} height={20} viewBox="0 0 16.471 20" {...props}><path d="M23.971 11.559h-4.706V4.5h-7.059v7.059H7.5l8.235 8.235zM7.5 22.147V24.5h16.471v-2.353z" data-name="Icon material-file-download" style={{
    fill: "rgba(60,60,60,.6)"
  }} transform="translate(-7.5 -4.5)" /></svg>;
export { SvgDownloadFilled as ReactComponent };